const strings = {
    welcomeMessage: 'Bem vindo(a) ao Sistema digital para reserva e agendamentos de utilização do serviço público de alagem',
    welcomeMessage2: 'Para prosseguir, por favor, inicie sessão',
    email: 'Email',
    password: 'Senha',
    passwordMessage: 'Pelo menos 8 caracteres, uma maiúscula e um número.',
    rememberUser: 'Lembrar utilizador',
    recoverPassword: 'Recuperar senha',
    createAccount: 'Criar conta',
    regist: 'Registo',
    login: 'Entrar',
    invalidEmailOrPassword: 'Email ou senha incorretos.',
    insertEmail: 'Inserir email',
    insertPassword: 'Inserir senha',
    name: 'Primeiro e último nome',
    insertName: 'Inserir primeiro e último nome',
    nif: 'NIF',
    insertNif: 'Inserir NIF',
    address: 'Morada',
    insertAddress: 'Inserir morada',
    zipCode: 'Código postal',
    insertZipCode: 'Inserir código postal',
    locality: 'Localidade',
    insertLocality: 'Inserir localidade',
    insertEmailError: 'Por favor insira um email.',
    invalidEmail: 'Por favor insira um email válido.',
    insertPasswordError: 'Por favor insira uma senha.',
    invalidPassword: 'Por favor insira uma senha válida.',
    insertNameError: 'Por favor insira um nome.',
    insertNifError: 'Por favor insira um NIF.',
    invalidNif: 'Por favor insira um NIF válido.',
    insertAddressError: 'Por favor insira uma morada.',
    insertZipCodeError: 'Por favor insira um código postal.',
    invalidZipCode: 'Por favor insira um código postal válido.',
    insertLocalityError: 'Por favor insira uma localidade.',
    register: 'Registar',
    registerSuccess: 'O seu registo foi efetuado com sucesso!',
    goToLogin: 'Ir para o início de sessão',
    recoverPasswordMessage: 'Introduza o seu endereço de e-mail de registo abaixo. Irá receber um código para alterar a sua senha.',
    send: 'Enviar',
    notRegisteredEmail: 'Se existir uma conta com este e-mail, será enviado um e-mail com as instruções para recuperar a conta.',
    recoverCode: 'Código de recuperação',
    recoverCodeMessage: 'Consulte o seu endereço de e-mail e introduza o código abaixo.',
    insertRecoverCode: 'Inserir código de recuperação',
    insertRecoverCodeError: 'Por favor insira o código de recuperação.',
    invalidRecoverCode: 'O código de recuperação que introduziu está incorreto.',
    validate: 'Validar',
    newPassword: 'Nova senha',
    newPasswordMessage: 'Introduza abaixo a sua nova senha.',
    insertNewPassword: 'Inserir nova senha',
    invalidNewPassword: 'A sua nova senha não pode ser igual à antiga.',
    setNewPassword: 'Definir nova senha',
    newPasswordSuccess: 'Nova senha definida com sucesso!',
    title: 'Sistema de Gestão de Estaleiros Navais e Alagem',
    exit: 'Sair',
    schedules: 'Agendamentos',
    boats: 'Embarcações',
    nextSchedules: 'Próximos',
    past: 'Histórico',
    newSchedule: 'Novo agendamento',
    reschedule: 'Reagendado',
    reschedule2: 'Remarcar',
    rejected: 'Rejeitado',
    inCheck: 'Em verificação',
    confirmed: 'Confirmado',
    noSchedules: 'Sem agendamentos',
    linesPerPage: 'Linhas por página',
    of: 'de',
    seeSchedule: 'Visualizar agendamento',
    rejectSuggestion: 'Rejeitar sugestão',
    acceptSuggestion: 'Aceitar sugestão',
    discard: 'Descartar',
    cancelSchedule: 'Cancelar agendamento',
    info: 'Informações',
    boatToIntervene: 'Embarcação a intervencionar',
    interventionLocal: 'Local de intervenção',
    interventionType: 'Tipo de intervenção',
    electricitySupply: 'Fornecimento de energia elétrica',
    yes: 'Sim',
    no: 'Não',
    fairing: 'Querenagem',
    putToDry: 'Pôr a seco',
    date: 'Data',
    startTime: 'Hora de início',
    endTime: 'Hora de fim',
    duration: 'Duração',
    putToSwim: 'Pôr a nado',
    lineChange: 'Mudança de linha',
    supplyPersonnel: 'Fornecimento de pessoal',
    numberOfMen: 'Número de homens',
    stay: 'Estadia',
    startDate: 'Data de início',
    endDate: 'Data de fim',
    numberOfDays: 'Número de dias',
    ripping: 'Ripagem',
    serviceDescription: 'Descrição do serviço',
    contractedPower: 'Potência contratada',
    back: 'Voltar',
    signOut: 'Terminar sessão?',
    signOutMessage: 'Tem a certeza que pretende terminar a sessão?',
    signOutTitle: 'Terminar Sessão',
    select: 'Selecionar',
    cancel: 'Cancelar',
    next: 'Seguinte',
    invalidDate: 'Por favor selecione uma data válida.',
    invalidTime: 'Por favor selecione uma hora válida.',
    write: 'Escrever...',
    schedule: 'Agendar',
    insertContractedPower: 'Inserir potência contratada',
    kw: 'kW',
    mooring: 'Acostagem',
    durationInDays: 'Duração em dias',
    yourBoats: 'As suas embarcações',
    addBoat: 'Adicionar embarcação',
    noBoats: 'Sem embarcações',
    seeBoat: 'Visualizar embarcação',
    update: 'Editar',
    remove: 'Remover',
    boatName: 'Nome da embarcação',
    registration: 'Matrícula',
    grossTonnage: 'Gross Tonnage',
    outOutLength: 'Comprimento fora-a-fora',
    outOutLength2: 'Comprim. fora-a-fora (M)',
    typeOfUse: 'Tipo de utilização',
    affectedShipyard: 'Estaleiro afeto',
    grt: ' GRT',
    grt2: ' (GRT)',
    m: ' M',
    removeBoat: 'Remover embarcação?',
    removeBoatMessage: 'Ao remover vai apagar permanentemente a sua embarcação registada.',
    removeBoatTitle: 'Remover embarcação',
    keep: 'Manter',
    newBoat: 'Nova embarcação',
    add: 'Adicionar',
    insertBoatName: 'Inserir nome da embarcação',
    intertRegistration: 'Inserir matrícula',
    insertGrossTonnage: 'Inserir gross tonnage',
    insertOutOutLength: 'Inserir comprimento fora-a-fora',
    insertBoatNameError: 'Por favor insira um nome da embarcação.',
    intertRegistrationError: 'Por favor insira uma matrícula.',
    insertGrossTonnageError: 'Por favor insira um gross tonnage.',
    insertOutOutLengthError: 'Por favor insira um comprimento fora-a-fora.',
    selectTypeOfUseError: 'Por favor selecione um tipo de utilização.',
    selectAffectedShipyardError: 'Por favor selecione um estaleiro afeto.',
    selectAffectedShipyardError2: 'Por favor selecione pelo menos um estaleiro afeto.',
    updateBoat: 'Editar embarcação',
    save: 'Guardar',
    wait: 'Por favor, aguarde...',
    loginError: 'Ocorreu um erro no seu login.',
    harbor: 'Estaleiro',
    harbors2: 'Estaleiros',
    reports: 'Relatórios',
    unconfirmed: 'Por confirmar',
    scheduleInfo: 'Informações de agendamento',
    clientIdentification: 'Identificação do cliente',
    boatIdentification: 'Identificação da embarcação',
    service: 'Serviço',
    reject: 'Rejeitar',
    suggest: 'Sugerir',
    accept: 'Aceitar',
    details: 'Detalhes',
    exportReport: ' Exportar relatório',
    readings: 'Leituras (a preencher pelo técnico)',
    readings2: 'Leituras',
    initialReading: 'Leitura inicial',
    insertInitialReading: 'Inserir leitura inicial',
    finalReading: 'Leitura final',
    insertFinalReading: 'Inserir leitura final',
    boxNumber: 'Número de caixa',
    insertBoxNumber: 'Inserir número de caixa',
    consumptionAndPowerRate: 'Consumo e taxa de potência (a preencher pelo técnico)',
    consumptionAndPowerRate2: 'Consumo e taxa de potência',
    amount: 'Quantidade',
    insertAmount: 'Inserir quantidade',
    unitaryValue: 'Valor unitário',
    insertUnitaryValue: 'Inserir valor unitário',
    eur: '€',
    grossValue: 'Valor ilíquido',
    insertGrossValue: 'Inserir valor ilíquido',
    iva: 'IVA',
    subtotal: 'Sub-total',
    saveChanges: 'Guardar alterações',
    updateSchedule: 'Editar agendamento',
    suggestSchedule: 'Sugerir agendamento',
    suggestSchedule2: 'Sugestão de agendamento',
    suggestScheduleMessage: 'Ao efetuar uma sugestão de agendamento, o utilizador será notificado e terá a possibilidade de aceitar ou rejeitar as sugestões apresentadas.',
    confirmSuggestion: 'Confirmar sugestão',
    accessToFacilities: 'Acesso às instalações',
    energy: 'Energia',
    dateStartTime: 'Data / Hora de início',
    nrOfMen: 'Nº homens',
    workDescription: 'Descrição dos trabalhos',
    insert: 'Inserir...',
    day: 'dia',
    days: 'dias',
    user: 'Utilizador',
    userManagement: 'Gestão de utilizadores',
    entityManagement: 'Gestão de entidades',
    addUser: 'Adicionar utilizador',
    client: 'Cliente',
    harborTechnician: 'Técnico de Porto',
    harborAdmin: 'Administrador de Porto',
    dealer: 'Concessionário',
    profile: 'Perfil',
    seeDetails: 'Ver detalhes',
    updateUser: 'Editar utilizador',
    disableUser: 'Desativar utilizador',
    removeUser: 'Remover utilizador',
    addEntity: 'Adicionar entidade',
    enableUser: 'Ativar utilizador',
    search: 'Pesquisar',
    enterSearchTerms: 'Inserir termos de pequisa...',
    disableUserMessage: 'Tem a certeza que pretende desativar este utilizador?',
    enableUserMessage: 'Tem a certeza que pretende ativar este utilizador?',
    removeUserMessage: 'Tem a certeza que pretende remover este utilizador?',
    disable: 'Desativar',
    enable: 'Ativar',
    noUsersForSearch: 'Não existem utilizadores para esta pesquisa.',
    newUserClient: 'Novo utilizador: Cliente',
    accessEmail: 'Email de acesso',
    insertAccessEmail: 'Inserir email de acesso',
    createUser: 'Criar utilizador',
    newUserTechnician: 'Novo utilizador: Técnico de Porto',
    username: 'Nome de utilizador',
    insertUsername: 'Inserir nome de utilizador',
    insertUsernameError: 'Por favor insira um nome de utilizador.',
    skills: 'Competências',
    skills2: 'competências',
    skill: 'competência',
    newUserHarborAdmin: 'Novo utilizador: Administrador de Porto',
    selectEntityError: 'Por favor selecione uma entidade.',
    newUserDealer: 'Novo utilizador: Concessionário',
    entity: 'Entidade',
    noEntities: 'Sem entidades',
    disableEntity: 'Desativar entidade',
    disableEntityMessage: 'Tem a certeza que pretende desativar esta entidade?',
    enableEntity: 'Ativar entidade',
    enableEntityMessage: 'Tem a certeza que pretende ativar esta entidade?',
    removeEntity: 'Remover entidade',
    removeEntityMessage: 'Tem a certeza que pretende remover esta entidade?',
    updateEntity: 'Editar entidade',
    selectStateError: 'Por favor selecione um estado.',
    insertConcessionError: 'Por favor insira uma concessão.',
    newEntity: 'Nova entidade',
    concession: 'Concessão',
    insertConcession: 'Inserir concessão',
    name2: 'Nome',
    insertName2: 'Inserir nome',
    state: 'Estado',
    startDateConcession: 'Data de início de concessão',
    selectDateError: 'Por favor selecione uma data.',
    createEntity: 'Criar entidade',
    generateMonthlyReport: 'Gerar relatório mensal',
    generateReportBetweenDates: 'Gerar relatório entre datas',
    generateReport: 'Gerar relatório',
    adminit: 'Admin IT',
    addHarborTechnician: 'Adicionar técnico de porto',
    noInfo: 'Sem informação a mostrar.',
    selecteSkillsError: 'Por favor selecione pelo menos uma competência.',
    harbors: 'Portos',
    noMoreOptions: 'Não existem mais opções.',
    noOptions: 'Não existem opções.',
    createAccountDataError: 'Os dados de registo já estão a ser utilizados por outra conta.',
    createAccountEmailError: 'Este e-mail já está a ser utilizado.',
    createAccountError: 'Ocorreu um erro ao criar a sua conta.',
    passwordRecoveryError: 'Ocorreu um erro ao enviar e-mail.',
    recoverCodeError: 'Ocorreu um erro ao validar o código de acesso.',
    resetPasswordError: 'Ocorreu um erro ao alterar a sua senha.',
    getBoatsError: 'Ocorreu um erro ao listar as embarcações.',
    getDropdownsError: 'Ocorreu um erro ao listar os itens das dropdowns.',
    deleteBoatError: 'Ocorreu um erro ao remover a embarcação.',
    getBoatDetailsError: 'Ocorreu um erro ao listar os detalhes desta embarcação.',
    createBoatError: 'Ocorreu um erro ao criar a embarcação.',
    updateBoatError: 'Ocorreu um erro ao editar a embarcação.',
    error: 'Erro 404',
    notFound: 'Página não encontrada',
    backMainPage: 'Voltar à página inicial',
    mobile: 'Para utilizar o serviço de Alagem Digital no seu dispositivo móvel ou tablet, solicitamos que faça o download da aplicação, disponível para Android e iOS.',
    getUsersError: 'Ocorreu um erro ao listar os utilizadores ',
    active: 'Ativo',
    inactive: 'Inativo',
    deleted: 'Apagado',
    actions: 'Ações',
    getUserDetailsError: 'Ocorreu um erro ao listar os detalhes do utilizador.',
    userNotFound: 'Utilizador não encontrado.',
    notAuthorized: 'Não está autorizado a atualizar o utilizador.',
    disableUserError: 'Ocorreu um erro ao desativar o utilizador.',
    enableUserError: 'Ocorreu um erro ao ativar o utilizador.',
    deleteUserError: 'Ocorreu um erro ao remover o utilizador.',
    updateUserError: 'Ocorreu um erro ao editar o utilizador.',
    getSkillsError: 'Ocorreu um erro ao listar os itens das competências.',
    createUserError: 'Ocorreu um erro ao criar o utilizador.',
    getEntitiesError: 'Ocorreu um erro ao listar as entidades.',
    entityNotFound: 'Entidade não encontrada.',
    notAuthorizedEntity: 'Não está autorizado a atualizar a entidade.',
    disableEntityError: 'Ocorreu um erro ao desativar a entidade.',
    enableEntityError: 'Ocorreu um erro ao ativar a entidade.',
    deleteEntityError: 'Ocorreu um erro ao remover a entidade.',
    getHarborsByEntityError: 'Esta entidade não possui portos.',
    time: 'Hora',
    boat: 'Embarcação',
    getIntervetionTypesError: 'Ocorreu um erro ao listar os tipos de intervenção.',
    createScheduleError: 'Ocorreu um erro ao criar o agendamento.',
    getScheduleDetailsError: 'Ocorreu um erro ao listar os detalhes deste agendamento.',
    justificationSchedulingSuggestion: 'Justificação para a sugestão de agendamento',
    dateInfo: 'Em todos os campos de seleção de data, os dias apresentados a cinzento não estão disponíveis para marcação.',
    closingDate: 'Data de fecho',
    customerCommunication: 'Comunicação com o cliente',
    justifyReschedule: 'Justifique a razão para o reagendamento',
    getSchedulesError: 'Ocorreu um erro ao listar os agendamentos.',
    rejectScheduleError: 'Ocorreu um erro ao rejeitar o agendamento.',
    acceptScheduleError: 'Ocorreu um erro ao aceitar o agendamento.',
    suggestScheduleError: 'Ocorreu um erro ao reagendar o agendamento.',
    getClientBoatsError: 'Ocorreu um erro ao listar os barcos do utilizador.',
    discardScheduleError: 'Ocorreu um erro ao descartar o agendamento.',
    cancelScheduleError: 'Ocorreu um erro ao cancelar o agendamento.',
    noNextSchedules: 'Não existem agendamentos próximos.',
    noPastSchedules: 'Não existem agendamentos passados.',
    getUserHarborError: 'Ocorreu um erro ao obter o porto do utilizador.',
    getExcludedDatesError: 'Ocorreu um erro ao listar as datas não disponíveis.',
    updateEnergyValuesError: 'Ocorreu um erro ao inserir os dados relativos à energia elétrica.',
    equipments: 'Equipamentos (a preencher pelo técnico)',
    equipments2: 'Equipamentos',
    equipmentType: 'Tipo de equipamento',
    travelLift: 'Travel-lift',
    agriculturalTractor: 'Trator tipo agrícola',
    automobileCrane5T: 'Guindaste automóvel 5T',
    automobileCrane10T: 'Guindaste automóvel 10T',
    updateEquipmentError: 'Ocorreu um erro ao inserir os dados relativos ao equipamento.',
    getEquipmentsError: 'Ocorreu um erro ao listar os equipamentos.',
    exportToExcelError: 'Ocorreu um erro ao exportar para Excel.',
    noSchedulesFoundError: 'Não foram encontrados agendamentos para o período especificado.',
    updateEntityError: 'Ocorreu um erro ao editar a entidade.',
    getEntityDetailsError: 'Ocorreu um erro ao listar os detalhes da entidade.',
    newEntityInfo: 'Preencha todas as informações essenciais da entidade e escolha quais os seus estaleiros de atuação.',
    newEntitySkillsInfo: 'Na coluna da esquerda selecione o porto e, de seguida, selecione as competências relevantes ao mesmo porto na coluna da direita.',
    continue: 'Continuar',
    createEntityError: 'Ocorreu um erro ao criar a entidade.',
    createEntityNIFError: 'Já existe uma entidade com este NIF.',
    requiredInfo: 'Todos os campos com',
    requiredInfo2: 'são obrigatórios.',
    incorrectDatesError: 'As datas dos campos opcionais não estão dentro do intervalo das datas de Estadia',
    noEntitiesForSearch: 'Não existem entidades para esta pesquisa.',
    harborSkills: 'Estaleiros e competências',
    electricitySupply2: 'Forn. energia',
    accessFacilities: 'Acesso instalações',
    getHarborInterventionTypesError: 'Ocorreu um erro ao listar os serviços deste porto.',
    getClientDetailsError: 'Ocorreu um erro ao listar os detalhes do seu perfil.',
    deleteAccount:'Apagar conta',
    deleteClient: 'Apagar a sua conta?',
    deleteClientMessage: 'Ao confirmar vai apagar permanentemente a sua conta registada.',
    createEntity2: 'Criação de entidade',
    confirm: 'Confirmar',
    createEntityMessage: 'Ao criar uma entidade, as competências ficam associadas aos portos. Tem a certeza que pretende associar estas competências a estes portos?',
    editEntity: 'Edição de entidade',
    editEntityMessage: 'Ao editar uma entidade, as competências ficam associadas aos portos. Tem a certeza que pretende associar estas competências a estes portos?',
    getDocapescaIdError: 'Ocorreu um erro ao listar os detalhes da entidade Docapesca.',
    delete: 'Apagar',
    deleteSchedule: 'Apagar agendamento',
    past2: 'Passados',
    cancelSchedule2: 'Cancelar agendamento?',
    cancelScheduleMessage: 'Ao remover o agendamento será apagado permanentemente e terá custos associados.',
    privacy: 'Política de Privacidade',
    developedBy: 'Desenvolvido por'
}

export default strings